export const idCardNoReg = /^\d{17}[0-9Xx]$/
export const bankCardNoReg = /^\d{16,19}$/
